export function LinkShareIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M6.343 17.657a3 3 0 010-4.243l2.121-2.121A1 1 0 007.05 9.879L4.93 12a5 5 0 000 7.071l.353.354a4.5 4.5 0 006.364 0l.62-.62a1 1 0 00-1.415-1.413l-.619.618a2.5 2.5 0 01-3.535 0l-.354-.353z"
      ></path>
      <path
        fill="currentColor"
        d="M9.171 13.414a1 1 0 101.415 1.414l4.242-4.242a1 1 0 00-1.414-1.414l-4.243 4.242z"
      ></path>
      <path
        fill="currentColor"
        d="M9.879 8.464a1 1 0 010-1.414l2.12-2.121a5 5 0 017.072 0l.353.353a4.5 4.5 0 010 6.364l-.618.62a1 1 0 01-1.414-1.415l.618-.619a2.5 2.5 0 000-3.535l-.353-.354a3 3 0 00-4.243 0l-2.121 2.121a1 1 0 01-1.414 0zM23 14a2 2 0 01-2.728 1.863L17.977 17.7c.015.098.023.199.023.301v.034l2.029 1.217A2 2 0 1119 21v-.034l-2.029-1.217a2 2 0 11-.243-3.612l2.294-1.836A2 2 0 1123 14z"
      ></path>
    </svg>
  );
}
